import { createTheme, ThemeProvider as MuiThemeProvider, useTheme as useMuiTheme } from "@mui/material"

export const theme = createTheme({
	shape: {
		borderRadius: 6, // Default border radius
	},
	palette: {
		primary: {
			main: "#1976d2",
			light: "#42a5f5",
			dark: "#1565c0",
		},
		secondary: {
			main: "#757575",
		},
		success: {
			main: "#2e7d32",
			light: "#4caf50",
			dark: "#1b5e20",
		},
		info: {
			main: "#0288d1",
			light: "#03a9f4",
			dark: "#01579b",
		},
		warning: {
			main: "#ed6c02",
			light: "#FFC107",
		},
		error: {
			main: "#d32f2f",
		},
		grey: {
			50: "#fafafa",
			100: "#f5f5f5",
			200: "#eeeeee",
			300: "#e0e0e0",
			400: "#bdbdbd",
			500: "#9e9e9e",
			600: "#757575",
			700: "#616161",
			800: "#424242",
			900: "#212121",
		},
	},
	typography: {
		fontFamily: "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Arial, sans-serif",
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: "none",
				},
			},
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					backgroundColor: "#fafbfc",
					borderColor: "rgba(21,33,159,.1) !important",
					outlineColor: "black",
					"& input": {
						padding: "0.5rem 0.75rem",
					},
				},
			},
		},
		MuiLink: {
			styleOverrides: {
				root: {
					textDecoration: "none",
					fontWeight: 700,
				},
			},
		},
        MuiAutocomplete: {
            defaultProps: {
                filterOptions: (options) => options
            }
        },
	},
	spacing: 8,
})

export default theme

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
	return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
}

export const useTheme = () => useMuiTheme() as typeof theme
